<template>
    <div id="sitebar_filters">        
        <div class="d-flex justify-content-between align-items-center mb-4">
            <h3>Filters</h3>            
        </div>
        <div>
            <h5 class="block_top_panel__title mt-5">Report time</h5>                        
            <div class="d-flex align-items-center mb-3">                
                <div class="black_block__title">Begin</div>
                <input 
                    class="form-control form-control-filters" 
                    type="datetime-local"
                    v-model="report.date_begin"
                >                
                <div class="btn-close"></div>
            </div>            
            <div class="d-flex align-items-center mb-3">
                <div class="black_block__title">End</div>
                <input 
                    type="datetime-local"
                    class="form-control form-control-filters" 
                    v-model="report.date_end"
                    placeholder="Select date and time"
                >
                <div class="btn-close"></div>
            </div>            
            <div v-for="(video) in videos" :key="'rv' + video.id" class="videoBox d-flex flex-wrap">
                <div class="cb mt-2 titleWrap">
                    <input v-model="video.checked" @change="changeItem" :id="`t_${video.id}`" type="checkbox" class="custom_checkbox">
                    <label :for="`t_${video.id}`" class="mt-1">
                        <h5 class="block_top_panel__title mt-2">{{video.id}} Video {{video.name}}</h5>
                    </label>
                </div>
                <div class="d-flex flex-wrap vDates">
                    <div  class="d-flex align-items-center mb-3 me-3">
                        <div class="black_block__title">Begin</div> 
                        <span>{{video.beginf}}</span>
                    </div>
                    <div class="d-flex align-items-center mb-3">
                        <div class="black_block__title">End</div>
                        <span>{{video.endf}}</span>
                    </div>
                </div>
            </div>
            <div class="input_search input_search_border mb-4">
                <input 
                    v-model="restVideosParams.find" 
                    type="text" 
                    placeholder="Search" 
                    class="form-control text-grey" 
                    name="searchRestVideos"
                >
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#9F9F9F"/>
                </svg>
            </div>
            <div class="rvideos-cards_wrap">
                <div v-for="(video) in restVideosP" :key="video.id" class="videoBox d-flex flex-wrap">
                    <div class="cb mt-2 titleWrap">
                        <input v-model="video.checked" @change="changeItem" :id="`t_${video.id}`" type="checkbox" class="custom_checkbox">
                        <label :for="`t_${video.id}`" class="mt-1">
                            <h5 class="block_top_panel__title mt-2">{{video.id}} Video {{video.name}}</h5>
                        </label>
                    </div>
                    <div class="d-flex flex-wrap vDates">
                        <div  class="d-flex align-items-center mb-3 me-3">
                            <div class="black_block__title">Begin</div> 
                            <span>{{video.beginf}}</span>
                        </div>
                        <div class="d-flex align-items-center mb-3">
                            <div class="black_block__title">End</div>
                            <span>{{video.endf}}</span>
                        </div>
                    </div>
                </div>
            </div>
            
            
            
            <div class="block_top_panel block_top_panel_updown d-flex justify-content-between align-items-center mb-4 mt-5">
                <h5 class="block_top_panel__title">Category and person</h5>
                <div class="cb">
                    <div class="cb_left">                        
                        <input v-model="showAllUnk.checked" @change="unkVsibility" id="g112" type="checkbox" class="custom_checkbox">
                        <label for="g112">Show unknown persons</label>
                    </div>
                </div>
            </div>



                            
            <div v-for="(category, index) in categories" :key="'cat' + category.id">                
                <div  class="cb cb_category cb_2_column">
                    <div class="cb_left">
                        <input 
                            v-model="category.checked" 
                            :id="'rcats_' + category.id" 
                            type="checkbox" 
                            class="custom_checkbox"
                            @change="changeCat(index, 'categories')"
                        >
                        <label :for="'rcats_' + category.id">{{category.name}}</label>
                    </div>
                    <div class="cb_right">{{category.id}}</div>
                </div>                
                <div v-for="(person) in category.persons" :key="'pers' + person.id" class="cb cb_2_column" v-show="person.visible">
                    
                        <div class="cb_left">
                            <input 
                                v-model="person.checked"
                                :id="'pers' + person.id" 
                                type="checkbox" 
                                class="custom_checkbox"
                                @change="changePers"
                            >
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <label :for="'pers' + person.id">
                                {{person.first_name}} {{person.last_name}}
                            </label>
                        </div>
                        <div class="cb_right">
                            {{person.id}}
                        </div>
                    
                </div>
            </div>
             
             <div class="input_search input_search_border mb-4 mt-4">
                <input 
                    v-model="restCategoriesParams.find" 
                    type="text" 
                    placeholder="Search" 
                    class="form-control text-grey"
                >
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#9F9F9F"/>
                </svg>
            </div>

            <div class="rcategories-cards_wrap">             
                <div v-for="(category, index) in restCategories" :key="'rc' + category.id">                
                    <div  class="cb cb_category cb_2_column">
                        <div class="cb_left">
                            <input 
                                v-model="category.checked" 
                                :id="'rcats_' + category.id" 
                                type="checkbox" 
                                class="custom_checkbox"
                                @change="changeCat(index, 'restCategories')"
                            >
                            <label :for="'rcats_' + category.id">{{category.name}}</label>
                        </div>
                        <div class="cb_right">{{category.id}}</div>
                    </div>
                    <div class="rpersons-cards_wrap">
                        <div v-for="(person) in category.persons" :key="'pers' + person.id" class="cb cb_2_column" v-show="person.visible">
                            <div class="cb_left">
                                <input 
                                    v-model="person.checked" 
                                    :id="'pers' + person.id" 
                                    type="checkbox" 
                                    class="custom_checkbox"
                                    @change="changePers"
                                >
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <label :for="'pers' + person.id">
                                    {{person.first_name}} {{person.last_name}}
                                </label>
                            </div>
                            <div class="cb_right">
                                {{person.id}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>                                    
            <div class="mt-5">                
                <!-- <button class="btn btn-border w-100">SAVE FILTERS</button>
                <button class="mt-3 btn btn-link w-100">CLEAR ALL</button> -->
                <div class="d-flex align-items-center mb-3">                
                    <div class="black_block__title">New report name</div>
                    <input 
                        class="form-control form-control-filters" 
                        type="text"
                        v-model="new_name"
                    >                
                    <div class="btn-close"></div>
                </div>    
                <button @click="addReport" class="mt-5 btn btn-primary w-100">SAVE REPORT AS</button>
            </div>
        </div>
    </div>
</template>

<script>
import {bus} from '../../bus';
import hrdate from "../hrdate";
export default {
    props: ['report_id'],
    data(){
        return{
            model_filter: {
              global_begin: '',
              global_end: '',
              video_begin: '',
              video_end: ''
            },
            // categories: [],
            model_category: 'all',
            change_category: [],
            data: [],
            report: {},
            vids: [],
            pids: [],
            dbinp: '',
            new_name: '',            
            uuids: [],            
            restVideosParams: {
                countitempage: 10,
                step: 10,
                sort: 'name',
                sorttype: 'asc',
                find: '',
                page: 1,
                model_find: ''
            },
            restVideos: [],
            restCategoriesParams: {
                countitempage: 10,
                step: 10,
                sort: 'name',
                sorttype: 'asc',
                find: '',
                page: 1,
                model_find: ''
            },
            restCategories: [],            
            waitingForAnResponse: false,
            isLoad: false,
            showAllUnk: {
                checked: true
            }
        }
    },
    methods: {        
        filterPersonsByUnknown(categories){
            let filteredCategories = categories.map(category=>{                
                category.persons = category.persons.map(person=>{                    
                    if(person.first_name.includes('unknown')){
                        person.visible = this.showAllUnk.checked;
                    }                    
                    return person;
                });
                return category;
            })
            return filteredCategories;
        },        
        unkVsibility(){
            console.log('Click to show all unk')
            console.log('this.showAllUnk.checked', this.showAllUnk.checked);
            this.categories = this.filterPersonsByUnknown(this.categories);
            this.restCategories = this.filterPersonsByUnknown(this.restCategories);
        },
        changeItem(i){
            this.vids = [];
            this.videos.map((video, id) => {
                if(video.checked){                    
                    this.vids.push(video.id);
                }
            });
            this.restVideosP.map((video, id) => {
                if(video.checked){                    
                    this.vids.push(video.id);
                }
            });            
        },
        changePers(i){
            
            
            this.pids = [];
            this.uuids = [];

            console.log('this.categories from changePers: ', this.categories);

            this.categories.map( (category, id) => {                
                category.persons.map((person)=>{
                    if(person.checked){                    
                        this.pids.push(person.id);
                        this.uuids.push(person.uuid);
                    }                    
                });                
            });
            this.restCategories.map( (category, id) => {                
                category.persons.map((person)=>{
                    if(person.checked){                    
                        this.pids.push(person.id);
                        this.uuids.push(person.uuid);
                    }                    
                });                
            });
            console.log('this.pids', this.pids);

            // this.$store.commit('setReport', this.report);

        },
        changeCat(index, catsType){            
            this[catsType][index].persons.map((person, pindex)=>{
                const firstPersonChecker = document.getElementById(`pers${person.id}`);
                let pidIndex;
                if(this[catsType][index].checked){
                    firstPersonChecker.checked = true;
                    person.checked = true;
                    this.pids.push(person.id);
                } else {
                    firstPersonChecker.checked = false;
                    person.checked = false;                                         
                    pidIndex = this.pids.indexOf(person.id);
                    if (pidIndex > -1) this.pids.splice(pidIndex, 1);
                }                
            });
            console.log('this.pids', this.pids);
        },        
        scroll() {               
            let listRvideos = document.querySelector('.rvideos-cards_wrap')
            listRvideos.onscroll = () => {

                console.log('videos scroll');
                /*
                    clientHeight высота содержимого вместе с полями padding, но без полосы прокрутки.
                    offsetHeight «внешняя» высота блока, включая рамки.
                    scrollHeight полная внутренняя высота, включая прокрученную область.
                */                
                let bottomOfListRvideos =
                listRvideos.scrollTop + listRvideos.clientHeight + 10 >=
                listRvideos.scrollHeight;
                /* listRvideos.scrollHeight > 40 because otherwise it reacts to decreasing height when clearing the list
                    40 random approximate number */
                if (
                    bottomOfListRvideos && listRvideos.scrollHeight > 40
                    && 
                    !this.waitingForAnResponse
                ) {                    
                    this.loadingDataFromServer()
                }
            };
        },
        loadingDataFromServer() {                
            this.waitingForAnResponse = true    // flag for not reppeat before respons from server
            this.isLoad = true  // enable "Loading..." down list            
            this.restVideosParams.countitempage += this.restVideosParams.step;            
            // let response = this.getVideos();
            this.isLoad = false
        },
        getVideos(){
            let params = this.restVideosParams;
            let thisMainVideosIds = this.report.videos.map((video)=>{
                return video.id;
            });
            params.exceptIds = thisMainVideosIds;
            const url = `/getvideos`;            
            axios.get(
                url,            
                {
                    params: params,
                    headers: {
                        'ContentType': 'application/json'
                    }
                }                
            ).then((response) => {                
                this.data = response.data;
                this.restVideos = response.data.data;
                let countRestVideos = this.restVideos.length;
                this.changePageProp = false;
                this.waitingForAnResponse = false;
            }).catch( (error) => {
                // handle error
                console.log(error);
            });
        },
        getCategoriesIdsFromPersons(persons){
            let categoriesIds = [],
                curCatId;
            persons.map(person => {
                curCatId = person.categories[0].id;
                if( !categoriesIds.includes(curCatId) )
                    categoriesIds.push(curCatId);
            
            });
            return categoriesIds
        },
        getCategories(){
            let params = this.restCategoriesParams;
            let thisMainCategoriesIds = this.getCategoriesIdsFromPersons(this.report.persons);            
            params.exceptIds = thisMainCategoriesIds;

            console.log('thisMainCategoriesIds', thisMainCategoriesIds);

            const url = `/categories`;

            params.additionalList = 'y';

            axios.get(
                url,            
                {
                    params: params,
                    headers: {
                        'ContentType': 'application/json'
                    }
                }                
            ).then((response) => {
                this.data = response.data;
                this.restCategories = response.data.data;
                
                this.restCategories = this.restCategories.map(category=>{                
                    category.persons = category.persons.map(person=>{
                        person.visible = true;
                        return person;
                    });
                    return category;
                });                
                
                // this.restCategories = response.data;
                let countRestCategories = this.restCategories.length;

                console.log('this.restCategories', this.restCategories);

                // this.changePageProp = false;
                // this.waitingForAnResponse = false;
            }).catch( (error) => {
                // handle error
                console.log(error);
            });
        },
        addReport(){                        
            if(this.new_name == ''){
                alert('Enter new report name');
                return;
            }
            if(
                !this.vids.length
                && !this.pids.length
            ){
                alert('Choose at least one video or one person');
                return;
            }
            
            axios.post( 
                '/reports',                
                {
                    name: this.new_name,
                    video_id: this.vids,
                    // person_uuid: this.uuids,
                    person_id: this.pids,
                    date_begin: this.report.date_begin,
                    date_end: this.report.date_end
                },
                {
                    headers: {                        
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    onUploadProgress: (progressEvent) => {
                        let progress = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                        this.videos[id].progress = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                        if(progress === 100){
                            this.videos[id].done = true;
                        }
                    }
                }
            ).then((responce)=>{                
                console.log('responce: ', responce);
                if(responce.data.front_id){
                    this.videos[id].id = responce.data.id;
                    this.videos[id].date = hVue.convertTimestamp(responce.data.date);
                }
                location.href=`/reports/${responce.data.id}`;
            }).catch(function(){
                console.log('FAILURE!!');
            });
        },        
        getReport(){
            this.report = this.$store.getters.getReport;
        },
        addT(datePropName){
            this.report[datePropName] = this.report[datePropName].replace(/\s/g, 'T');
        },
        prepareVideosAr(videoAr, checked){
            let preparedAr = videoAr.map((video, id) => {                    
                    video.checked = checked;
                    video.beginf = (video.start_time || video.date) ? hVue.convertTimestamp(video.start_time || video.date) : '-';
                    video.endf = video.end_time ? hVue.convertTimestamp(video.end_time) : '-';                    
                    return video;
                });
            return preparedAr;
        },
        prepareCategoriesAr(personsAr, checked){
            let categories = {};
            // this.report.persons.map(person => {
            personsAr.map(person => {
                // person.checked = true;
                person.checked = checked;
                person.visible = true;

                let curPersons = categories[person.categories[0].id] ?
                    [...categories[person.categories[0].id].persons, person] :
                    [ person ];
                
                categories = { 
                    ...categories,                    
                    [person.categories[0].id]: {
                        ...person.categories[0],
                        persons: curPersons
                    }                    
                };
            });
            categories = Object.values(categories);
            categories = categories.map((category)=>{
                category.checked = true;                
                return category;
            });
            return categories;            
        },
        getReportCategories(){
            let categories = {};
            this.report.persons.map(person => {
                let curPersons = categories[person.categories[0].id] ?
                    [...categories[person.categories[0].id].persons, person] :
                    [ person ];
                
                categories = { 
                    ...categories,
                    [person.categories[0].id]: {
                        ...person.categories[0],
                        persons: curPersons
                    }                    
                };
            });
            categories = Object.values(categories);
            return categories;            
        }
    },
    mounted(){
        bus.$on('reportUpdate', () =>{
            this.getReport();
            this.vids = this.report.videos.map((video)=>video.id);
            
            this.pids = this.report.persons.map((person)=>person.id);
            
            if(this.report.date_begin) this.addT('date_begin'); 
            if(this.report.date_end) this.addT('date_end');
        });        

        bus.$on('reportUpdate', () =>{
            // console.log(this.report);
        });        
    },
    computed: {
        // report(){
        //     let report = this.$store.getters.getReport;
        //     if(report.date_begin) this.addT('date_begin'); 
        //     if(report.date_end) this.addT('date_end');
        //     return this.$store.getters.getReport;
        // },
        // vids(){
        //     return this.report.videos.map((video)=>video.id);
        // },
        // pids(){
        //     return this.report.persons.map((person)=>person.id);;
        // },
        categoriesItem(){
            return this.categories;
        },
        videos(){
            console.log('Computed videos fired! )');
            
            console.log('this.report.videos: ', this.report.videos);
            
            if(!this.report.videos) return [];            
            if(this.report.videos){
                let reportVideos = this.prepareVideosAr( this.report.videos, true );
                this.getVideos();
                this.scroll();
                return reportVideos;
            }
        },
        categories(){
            console.log('Computed categories fired! )');

            console.log('this.report.persons: ', this.report.persons);

            if(!this.report.persons) return [];            
            if(this.report.persons){
                
                let reportCategories = this.prepareCategoriesAr( this.report.persons, true );
                // let reportCategories = this.prepareCategoriesAr( true );
                this.getCategories();

                // this.pids.push(person.id);
                
                // reportCategories = reportCategories.map(category=>{
                //     category.persons = category.persons.map(person=>{
                //         // this.pids.push(person.id);
                //     });
                // })
                // console.log('this.pids.length: ', this.pids.length);
                // if( !this.pids.length ){
                //     console.log('!this.pids.length fired! )');                    
                //     reportCategories.map(category=>{
                //         category.persons.map(person=>{
                //             this.pids.push(person.id);
                //         });
                //     });
                // };
                // console.log('this.pids when init: ', this.pids);

                console.log('***********************************************************************************');
                console.log('***********************************************************************************');
                console.log('***********************************************************************************');

                // this.scroll();
                console.log('reportCategories from computed categories: ', reportCategories);

                return reportCategories;
            }
        },
        rcategories(){            
            return [];
            // return this.getReportCategories().map((category) => {                
            //     return {
            //         ...category,
            //         checked: true,
            //         persons: category.persons.map((person)=>{
            //             return {
            //                 ...person,
            //                 checked: true
            //             };
            //         })                    
            //     };
            // });
        },
        persons(){
            // if(!this.report.videos) return [];            
            // if(this.report.videos){
            //     let reportPersons = this.report.videos, true );
            //     this.getVideos();
            //     this.scroll();
            //     return reportVideos;
            // }
            
        },
        restVideosP(){
            if(!this.restVideos) return [];            
            if(this.restVideos){
                let restVideos = this.prepareVideosAr( this.restVideos, false );
                return restVideos;
            }            
        },
        restCategoriesP(){
            if(!this.restCategories) return [];            
            if(this.restCategories){
                return this.restCategories;
                // let restCategories = this.prepareCategoriesAr( this.restVideos, false );
                // return restCategories;
            }            
        }

    },
    components: {
        hrdate
    }
}
</script>

<style lang="scss" scoped>
.rvideos-cards_wrap {
    overflow: auto;
    height: 320px;
}

.rpersons-cards_wrap {
    overflow: auto;
    max-height: 320px;
}

@media screen and (min-width : 1500px) {
    .videoBox {
        .titleWrap {        
                width: 100%;
        }        
    }    
}

.block_top_panel__title {
    overflow-wrap: break-word;
    width: 98%;
}
#sitebar_filters{
    color: #E0E0E0;
    font-size: .9rem;
}
.category_select{
    display: flex;
    align-items: center;
    label{
        margin-right: 1rem;
    }
}
input, label, #select_count_item {
    cursor: pointer;
}
#select_count_item{
    outline: 0px;
    border: none;
    border-bottom: 1px solid #828282;
    box-shadow: none;
    border-radius: 0;    
    &:after{
        content: 'Up';
    }
    &:checked,
    &:focus{
        outline: 0px;
        border: none;
        border-bottom: 1px solid #828282;
        box-shadow: none;
    }
}
.selected_category{
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 1rem;
    .selected_category_item{
        background: rgba(255, 255, 255, 0.2);
        padding: 0.2rem 0.2rem 0.2rem 1rem;
        border-radius: 20px;
        color: #fff;
        align-items: center;
        display: flex;
        font-size: .8rem;
        .btn-close{
            margin-left: .5rem;
            width: 15px;
            height: 15px;
            //background: none;
            position: relative;
            min-width: 15px;
            min-height: 15px;
            &:before{
                width: 11px;
                top: 10px;
            }
            &:after{
                width: 11px;
                top: 10px;
            }
        }
    }
}
.black_block__title{
    min-width: 70px;
    text-align: left;
    margin-right: 1rem;
}
.form-control-filters{
    background: #001d2e;
    border-color: #001d2e;
    border-bottom: 1px solid;
}
.input_search.input_search_border{
    input{
        background: #001d2e;
    }
}
.cb_category{
    margin: .5rem 0;
}
.cb_2_column{
    display: grid;
    grid-template-columns: 1fr 100px;
    align-items: center;
    width: 100%;
    .cb_left{
        display: flex;
        align-items: center;
    }
}
</style>
